import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-use-cases',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './use-cases.component.html',
  styleUrl: './use-cases.component.scss',
})
export class UseCasesComponent {
  features: string[] = [
    'Create a postcard with a few clicks, or use a link from your website',
    'Share the link to let supporters send your message to their city, congressional district, or elected representative',
    'Recipients can scan a QR code to resend',
    'See metrics on the number of times a campaign has been forwarded'
  ];
}
